import { useEffect, useState } from 'preact/hooks'
import { Link } from '@/core'
import { AuthContent } from '@c/auth-app/auth-content'
import { useStore } from '@/core'
import { useRouter } from '@u'
import { fetch } from '@/core/utils/drf/fetch'
import { ConfirmEmailForm } from '../confirm-email-form'
import { useTranslation } from 'react-i18next'
import styles from './style.module.styl'

export const ConfirmEmailPage = () => {
  const { t } = useTranslation()
  const store = useStore()
  const router = useRouter()
  const [token] = store.use(['route', 'queries', 'token'])
  const [userId] = store.use(['route', 'queries', 'userId'])
  const [isError, setIsError] = useState(null)

  useEffect(async () => {
    let result
    if (token && userId) {
      try {
        result = await fetch('api.confirmEmail', {
          method: 'POST',
          body: { token: token, userId: userId },
        })
      } catch (err) {
        result = err
      }
      if (result.fieldErrors) {
        setIsError(result.fieldErrors.token)
      }
    }
  }, [isError])

  return (
    <>
      {(!token && !userId) || isError ? (
        <AuthContent
          title={
            !isError
              ? t('auth.confirmEmailPage.titles.confirm')
              : t('auth.confirmEmailPage.titles.unsuccessful')
          }
          extra={
            <Link name="login">
              {' '}
              {t('auth.confirmEmailPage.links.return_login')}
            </Link>
          }
        >
          {!isError ? (
            <>
              <p className={styles.detail}>
                {t('auth.confirmEmailPage.messages.check_email')}
              </p>
              <p className={styles.detail}>
                {t('auth.confirmEmailPage.messages.cant_find')}
              </p>
            </>
          ) : (
            <p className={styles.detail}>{isError}</p>
          )}
          <ConfirmEmailForm
            onSuccess={() => {
              router.push({ name: 'confirmEmailSuccess' })
            }}
          />
        </AuthContent>
      ) : (
        <>
          <AuthContent
            title={t('auth.confirmEmailPage.titles.confirmed')}
            extra={
              <Link name="login">
                {t('auth.confirmEmailPage.links.return_login')}
              </Link>
            }
          >
            <p className={styles.detail}>
              {t('auth.confirmEmailPage.messages.login_complete')}
            </p>
          </AuthContent>
        </>
      )}
    </>
  )
}
